export class AudioAsset {
    constructor(audio) {
        this.audio = audio;
    }
}
//# sourceMappingURL=audio-asset.js.map